export const referralWhiteLocale = ['eu', 'uk', 'de', 'fr', 'es', 'it', 'au', 'kr', 'us', 'ca', 'za', 'jp', 'br', 'mx', 'ph', 'nl'];
export const withdrawalWhiteLocale = ['us', 'ca', 'au', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'za', 'jp', 'kr', 'br', 'mx', 'ph', 'nl'];
